module.exports = __webpack_public_path__ + "assets/media/information_swallow_recent.e4b20b40.mp4";